<template>
  <div
    class="auth"
    id="auth"
  >
    <div class="listLogo">
      <img
        src="../../assets/img/listLogo.png"
        alt
      />
      <span>主体管理</span>
    </div>
    <div class="titileContent">
      <div class="formContainer">
        <el-form
          label-suffix=":"
          :inline="true"
          ref="ruleForm"
          label-width="100px"
          :model="filterForm"
        >
          <el-form-item label="主体类型">
            <el-select
              clearable
              v-model="filterForm.type"
              placeholder="请选择主体类型"
              @change="handleSearch"
            >
              <el-option value="" label="全部"></el-option>
              <el-option v-for="item in subjectType" :value="item.id" :key="item.id" :label="item.cn"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主体阶段">
            <el-select
              clearable
              v-model="filterForm.stage"
              placeholder="请选择主体阶段"
              @change="handleSearch"
            >
              <el-option value="" label="全部"></el-option>
              <el-option v-for="item in subjectStage" :value="item.id" :key="item.id" :label="item.cn"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="请输入主体名称"
              v-model.trim="filterForm.name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title-bar">
        <div class="title">
          <div class="icon-content">
            <span class="rect rect-1"></span>
            <span class="rect rect-2"></span>
          </div>
        </div>
        <div>
          <el-button class="addBtn" type="primary"
                     icon="el-icon-plus" @click="handleAdd">新增主体</el-button>
          <el-button type="danger"
                     icon="el-icon-delete" :disabled="!selectRows.length" @click="handleDelete(selectRows)">删除</el-button>
        </div>
      </div>
      <div class="auth-table">
        <CustomTable
            ref="table"
            :data="tableData"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" reserve-selection></el-table-column>
          <el-table-column label="主体名称" prop="name"></el-table-column>
          <el-table-column label="客户名称" prop="customer"></el-table-column>
          <el-table-column label="主体类型" prop="typeCn"></el-table-column>
          <el-table-column label="主体阶段" prop="stageCn"></el-table-column>
          <el-table-column label="授权方式">
            <template slot-scope="scope">
              {{scope.row.grantType ==  0 ? '离线' : '在线'}}
            </template>
          </el-table-column>
          <el-table-column label="创建者" prop="creator"></el-table-column>
          <el-table-column label="创建时间" prop="createTime" width="180">
            <template slot-scope="scope">
              <span>{{scope.row.createTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column label="授权信息">
            <template slot-scope="scope">
              <div class="btn-wrapper" v-if="scope.row.grantType === 1">
                <template v-if="scope.row.grantStatus === 1">
                  <el-link :underline="false" :disabled="scope.row.loading" type="primary"  @click="handleAddAuth(scope.row, scope.row.grantType)">{{scope.row.loading?"授权中...":"生成授权"}}</el-link>
                </template>
                <template v-else>
                  <el-link type="success" @click="handleDetail(scope.row)">详情</el-link>
                  <el-link type="warning" @click="handleDownload(scope.row)">下载</el-link>
                  <el-link type="danger" @click="handleRevokeAuth(scope.row)">移除</el-link>
                </template>
              </div>
              <div class="btn-wrapper" v-else>
                <el-link :underline="false" :disabled="scope.row.loading" type="primary"  @click="handleAddAuth(scope.row, scope.row.grantType)">{{scope.row.loading?"授权中...":"生成授权"}}</el-link>
                <el-link :underline="false" :disabled="scope.row.loading" type="warning"  @click="handleAuthList(scope.row)">{{scope.row.loading?"授权中...":"授权列表"}}</el-link>
              </div>
            </template>
          </el-table-column>
        </CustomTable>
      </div>
    </div>
    <!--新增主体-->
    <KLDialog :visible="subjectDialogVisible" @close="handleCloseDialog" @submit="handleSubmit">
      <div slot="title">{{isEdit?'编辑主体':'新增主体'}}</div>
      <el-form ref="subjectForm" :model="subjectForm" :rules="subjectFormRules" label-width="100px" label-position="left">
        <el-form-item label="主体名称" prop="name">
          <el-input :disabled="isEdit" v-model="subjectForm.name" placeholder="请输入主体名称"></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerId">
          <el-select :disabled="isEdit" style="width: 100%" clearable filterable v-model="subjectForm.customerId" placeholder="请选择客户">
            <el-option v-for="item in customList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主体类型" prop="type">
          <el-select style="width: 100%" v-model="subjectForm.type" placeholder="请选择主体类型">
            <el-option v-for="item in subjectType" :value="item.id" :key="item.id" :label="item.cn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主体阶段" prop="stage">
          <el-select style="width: 100%" v-model="subjectForm.stage" placeholder="请选择主体阶段">
            <el-option v-for="item in subjectStage" :value="item.id" :key="item.id" :label="item.cn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权方式" prop="grantType">
          <el-radio-group :disabled="isEdit" v-model="subjectForm.grantType">
            <el-radio :label="1" selected>在线授权</el-radio>
            <el-radio :label="0">离线授权</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </KLDialog>

<!--    在线授权-->
    <KLDialog :visible="authDialogVisible" @submit="handleSubmitAuth" @close="handleCloseAuthDialog">
      <div slot="title">{{isAddAuth?'生成授权':'授权详情'}}</div>
      <el-form ref="authForm" :model="authForm" :rules="authFormRules" label-width="110px" label-position="left">
        <el-form-item label="节点数量" prop="nodeNumber">
          <el-input-number style="width: 100%" v-model.number="authForm.nodeNumber" :step="10" :min="0" :max="1000" placeholder="请输入节点数量"></el-input-number>
        </el-form-item>
        <el-form-item label="授权相机路数" prop="cameraNumber">
          <el-input-number style="width: 100%" v-model.number="authForm.cameraNumber" :step="10" :min="0" :max="100000" placeholder="授权接入相机路数"></el-input-number>
        </el-form-item>
        <el-form-item label="到期时间" prop="expireTime">
          <el-date-picker
            style="width: 100%"
            :default-value="authForm.expireTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="authForm.expireTime"
            default-time="23:59:59"
            type="date"
            :picker-options="pickerOptions"
            placeholder="选择到期日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="授权能力" prop="abilities">
          <el-select filterable multiple style="width: 100%" v-model="authForm.abilities" placeholder="请选择授权能力">
            <el-option v-for="item in aiList" :value="item.id" :key="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最大并发数" prop="concurrentAbility">
          <el-input-number style="width: 100%" v-model.number="authForm.concurrentAbility" :step="10" :min="0" placeholder="请输入最大并发数"></el-input-number>
        </el-form-item>
        <template v-if="!isAddAuth">
          <el-form-item label="收集记录时长">
            <span>{{authForm.useTime===-1?'未开始使用':formatDay(authForm.useTime)}}</span>
          </el-form-item>
          <el-form-item label="授权剩余路数">
            <span>{{authForm.cameraNumber - authForm.useCameraNumber}}</span>
          </el-form-item>
          <el-form-item label="授权剩余节点">
            <span>{{authForm.nodeNumber - authForm.useNodeNumber}}</span>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" v-if="!isAddAuth">
        <el-button @click="handleCloseAuthDialog">关闭</el-button>
        <el-button @click="handleSubmitAuth">更新</el-button>
      </div>
    </KLDialog>

    <!--离线授权-->
    <el-dialog :title="isAddAuth ? '生成授权' : '授权详情'" :before-close="handleCloseAuthDialog" :visible.sync="outLineAuthDialogVisible" :closeOnClickModal="true" width="30%">
      <el-form ref="authForm" :model="authForm" :rules="authFormRules" label-width="110px" label-position="left">
        <el-form-item label="节点数量" prop="nodeNumber">
          <el-input-number style="width: 100%" v-model.number="authForm.nodeNumber" :step="10" :min="0" :max="1000" placeholder="请输入节点数量"></el-input-number>
        </el-form-item>
        <el-form-item label="授权相机路数" prop="cameraNumber">
          <el-input-number style="width: 100%" v-model.number="authForm.cameraNumber" :step="10" :min="0" :max="100000" placeholder="授权接入相机路数"></el-input-number>
        </el-form-item>
        <el-form-item label="到期时间" prop="expireTime">
          <el-date-picker
              style="width: 100%"
              :default-value="authForm.expireTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="authForm.expireTime"
              default-time="23:59:59"
              type="date"
              :picker-options="pickerOptions"
              placeholder="选择到期日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="授权能力" prop="abilities">
          <el-select filterable multiple style="width: 100%" v-model="authForm.abilities" placeholder="请选择授权能力">
            <el-option v-for="item in aiList" :value="item.id" :key="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最大并发数" prop="concurrentAbility">
          <el-input-number style="width: 100%" v-model.number="authForm.concurrentAbility" :step="10" :min="0" placeholder="请输入最大并发数"></el-input-number>
        </el-form-item>
        <el-form-item label="设备编码" prop="code">
          <el-upload
            class="upload-demo"
            action="/lice-serve/api/v1/offLicense/upload"
            ref="upload"
            :auto-upload="true"
            accept="file/lic"
            :on-success="uploadSuccess"
            :on-change="chooseFile"
            multiple>
            <!--          <i class="el-icon-upload"></i>-->
            <el-button size="mini"><i style="font-size: 15px" class="el-icon-upload"></i>上传文件</el-button>
            <div class="el-upload__tip" slot="tip">支持扩展名：txt</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="激活码">
          <el-input type="textarea" readonly v-model="authCode" size="small" rows="3" placeholder="显示激活码，请勿输入！"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="generateActivation">生成</el-button>
        <el-button type="primary" @click="exportSecret">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Moment from 'moment';
import CustomTable from '@/components/KL-Table';
import KLDialog from '@/components/KL-Dialog';
import API from '@/api';

export default {
  name: 'index',
  components: {
    CustomTable,
    KLDialog,
  },
  data() {
    return {
      userToken: localStorage.getItem('secureKey'),
      authCode: '', // 生成的授权码
      pickerOptions: {
        disabledDate(time) {
          return (time.getTime() + 60 * 60 * 1000 * 24) < Date.now();
        },
      },
      isEdit: false,
      isAddAuth: true,
      listQuery: { pageNo: 1, pageSize: 10 },
      filterForm: {
        type: '',
        stage: '',
      },
      total: 0,
      tableData: [],
      customList: [],
      aiList: [],
      subjectDialogVisible: false,
      authDialogVisible: false,
      outLineAuthDialogVisible: false,
      subjectForm: {},
      selectRows: [],
      loading: false,
      authForm: {
        cameraNumber: 50,
        abilities: [],
        code: '',
        concurrentAbility: 5,
      },
      subjectFormRules: {
        name: [{ required: true, message: '请输入客户名称' }, { max: 64, message: '客户名称不能超过64个字符' }],
        customerId: [{ required: true, message: '请选择客户' }],
        type: [{ required: true, message: '请输入主体类型' }],
        stage: [{ required: true, message: '请选择主体阶段' }],
        grantType: [{ required: true, message: '请选择授权方式' }],
      },
      authFormRules: {
        nodeNumber: [{ required: true, message: '请输入节点数量', trigger: 'blur' }],
        cameraNumber: [{ required: true, message: '请输入授权的相机路数', trigger: 'blur' }],
        expireTime: [{ required: true, message: '请选择到期时间', trigger: 'change' }],
        abilities: [{ required: true, message: '请选择授权能力', trigger: 'change' }],
        concurrentAbility: [{ required: true, message: '请输入最大并发数', trigger: 'blur' }],
      },
      subjectType: [],
      subjectStage: [],
    };
  },
  created() {
    this.handleGetList();
    this.handleGetCustomList();
    this.handleGetAiList();
    this.handleGetSubjectType();
    this.handleGetSubjectStage();
  },
  methods: {
    handleSearch() {
      this.listQuery.pageNo = 1;
      this.handleGetList();
    },
    formatDay(time) {
      // eslint-disable-next-line radix
      const days = parseInt(time / (1000 * 60 * 60 * 24));
      // eslint-disable-next-line radix
      const hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      // eslint-disable-next-line radix
      const minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
      // eslint-disable-next-line radix
      const seconds = parseInt((time % (1000 * 60)) / 1000);
      // eslint-disable-next-line radix
      return `${days} 天 ${hours}小时 ${minutes} 分钟 ${seconds}秒`;
    },
    handleDownload(row) {
      const params = {
        id: row.id,
      };
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      API.grantsDownload(params).then((res) => {
        loading.close();

        if (res.headers['content-disposition']) {
          const blob = new Blob([res.data], {
            // type: 'application/vnd.
            // openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            type: res.headers['content-type'],
            // word文档为application/msword,
            // pdf文档为application/pdf,
            // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8
          });
          const objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          const fname = decodeURI(
            res.headers['content-disposition'].split('=')[1],
          ); // 下载文件的名字
          link.href = objectUrl;
          link.setAttribute('download', fname);
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href); // 释放掉blob对象
          document.body.removeChild(link); // 下载完成移除元素
        } else {
          this.ab2str(res.data, (result) => {
            this.$message.error(result.message);
          });
        }

        // if (res.status === 200) {
        //   console.log(res.data);
        // }
      }).catch(() => {
        loading.close();
      });
      console.log(row);
    },
    ab2str(u, f) {
      const b = new Blob([u]);
      const r = new FileReader();
      r.readAsText(b, 'utf-8');
      r.onload = function () {
        if (f) {
          f.call(null, JSON.parse(r.result));
        }
      };
    },
    handleRevokeAuth(row) {
      const params = {
        id: row.id,
      };
      this.$confirm('确认移除当前主体的授权信息，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        API.grantsRevoke(params).then((res) => {
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '移除授权信息成功!',
            });
            this.handleGetList();
          }
        });
      }).catch((err) => err);
    },
    handleDelete(row) {
      const params = {
        ids: [],
      };
      if (Array.isArray(row)) {
        params.ids = row.map((item) => item.id);
      } else {
        params.ids = [row.id];
      }
      this.$confirm('删除主体会删除关联的授权信息，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        API.deleteSubject(params).then((res) => {
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            const totalPage = Math.ceil(
              (this.total - 1) / this.listQuery.pageSize,
            ); // 总页数
            this.listQuery.pageNo = this.listQuery.pageNo > totalPage
              ? totalPage
              : this.listQuery.pageNo;
            this.listQuery.pageNo = this.listQuery.pageNo < 1 ? 1 : this.listQuery.pageNo;
            this.handleGetList();
          }
        });
      }).catch((err) => err);
    },
    // 提交信息生成授权
    handleSubmitAuth() {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          const params = {
            subjectId: this.subjectForm.id,
            ...this.authForm,
          };
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          this.$set(this.subjectForm, 'loading', true);
          API.grantSubject(params).then((res) => {
            loading.close();
            this.$set(this.subjectForm, 'loading', false);
            if (res.status === 200) {
              this.$message.success('授权成功');
              this.handleGetList();
              this.handleCloseAuthDialog();
            }
          }).catch(() => {
            this.$set(this.subjectForm, 'loading', false);
            loading.close();
          });
          console.log(this.subjectForm);
          console.log(this.authForm);
        }
      });
    },
    handleDetail(row) {
      console.log(row);
      this.isAddAuth = false;
      const params = {
        id: row.id,
      };
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      API.detailSubject(params).then((res) => {
        loading.close();
        if (res.status === 200) {
          console.log(res.data);
          this.authForm = { ...res.data };
          this.authDialogVisible = true;
        }
      }).catch(() => {
        loading.close();
      });
    },
    // 生成授权
    handleAddAuth(row, type) {
      this.subjectForm = row;
      this.$set(this.subjectForm, 'loading', false);
      this.isAddAuth = true;
      this.authForm = { concurrentAbility: 5 };
      type === 0 ? this.outLineAuthDialogVisible = true : this.authDialogVisible = true;
      this.$nextTick(() => {
        this.$set(this.authForm, 'expireTime', `${Moment().subtract(-30, 'days').format('YYYY-MM-DD')} 23:59:59`);
        this.$refs.authForm.clearValidate();
      });
    },
    // 授权列表
    handleAuthList(row) {
      this.$router.push({ path: '/authList', query: { bodyId: row.id } });
    },
    handleCloseAuthDialog() {
      this.subjectForm = {};
      this.authForm = {};
      this.authDialogVisible = false;
      this.outLineAuthDialogVisible = false;
      this.authCode = '';
      this.$refs.upload.clearFiles();
    },
    // 选择了文件后回调
    chooseFile(file) {
      const fileType = file.name.split('.');
      if (fileType[1] !== 'txt') {
        this.$message.warning('请上传.txt格式的机器码文件');
        setTimeout(() => {
          this.$refs.upload.clearFiles();
        }, 100);
      }
    },
    uploadSuccess(params) {
      this.authForm.code = params.data;
    },
    // 生成激活码
    generateActivation() {
      // this.authForm.code = "7056454868456567455453456568455153";
      if (!this.authForm.code) {
        this.$message.warning('请上传机器码文件');
        return;
      }
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          const params = {
            subjectId: this.subjectForm.id,
            ...this.authForm,
          };
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          this.$set(this.subjectForm, 'loading', true);
          API.grantOffLine(params).then((res) => {
            loading.close();
            this.$set(this.subjectForm, 'loading', false);
            if (res.status === 200) {
              this.authCode = res.data;
              this.$message.success('授权成功');
              // this.handleGetList();
              // this.handleCloseAuthDialog();
            }
          }).catch(() => {
            this.$set(this.subjectForm, 'loading', false);
            loading.close();
          });
        }
      });
    },
    // 导出授权
    exportSecret() {
      const subjectId = this.subjectForm.id;
      const params = {
        id: subjectId,
      };
      API.exportSecret(params).then((res) => {
        if (res.headers['content-disposition']) {
          const blob = new Blob([res.data], {
            type: res.headers['content-type'],
          });
          const objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          const fname = decodeURI(
            res.headers['content-disposition'].split('=')[1],
          ); // 下载文件的名字
          link.href = objectUrl;
          link.setAttribute('download', fname);
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href); // 释放掉blob对象
          document.body.removeChild(link); // 下载完成移除元素
        } else {
          this.ab2str(res.data, (result) => {
            this.$message.error(result.message);
          });
        }
      });
    },
    handleGetSubjectType() {
      API.findSubjectType().then((res) => {
        if (res.status === 200) {
          this.subjectType = res.data;
        }
      });
    },
    handleGetSubjectStage() {
      API.findSubjectStage().then((res) => {
        if (res.status === 200) {
          this.subjectStage = res.data;
        }
      });
    },
    handleGetCustomList() {
      API.findClient({ pageNo: 1, pageSize: 99999 }).then((res) => {
        if (res.status === 200) {
          this.customList = res.data.records;
        }
      });
    },
    handleGetAiList() {
      API.getAlgorithm({ pageNo: 1, pageSize: 99999 }).then((res) => {
        if (res.status === 200) {
          this.aiList = res.data.records;
        }
      });
    },
    handleAdd() {
      this.subjectForm = {};
      this.subjectDialogVisible = true;
      this.isEdit = false;
      this.$nextTick(() => {
        this.$refs.subjectForm.clearValidate();
      });
    },
    handleCloseDialog() {
      this.subjectDialogVisible = false;
      this.subjectForm = {};
    },
    handleEdit(row) {
      this.isEdit = true;
      this.subjectForm = { ...row };
      this.subjectDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.subjectForm.clearValidate();
      });
    },
    // 提交新增
    handleSubmit() {
      this.$refs.subjectForm.validate((validate) => {
        if (validate) {
          const params = {
            ...this.subjectForm,
          };
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          if (!this.isEdit) {
            API.insertSubject(params).then((res) => {
              loading.close();
              if (res.status === 200) {
                this.filterForm = {
                  stage: '',
                  type: '',
                };
                this.listQuery.pageNo = 1;
                this.handleGetList();
                this.handleCloseDialog();
              }
            }).catch(() => {
              loading.close();
            });
          } else {
            delete params.createTime;
            delete params.creator;
            delete params.creatorId;
            API.modifySubject(params).then((res) => {
              loading.close();
              if (res.status === 200) {
                this.filterForm = {
                  stage: '',
                  type: '',
                };
                this.handleGetList();
                this.handleCloseDialog();
              }
            }).catch(() => {
              loading.close();
            });
          }
          console.log(123);
        }
      });
    },
    handleSizeChange(val) {
      this.listQuery.pageNo = 1;
      this.listQuery.pageSize = val;
      this.handleGetList();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNo = val;
      this.handleGetList();
    },
    handleGetList() {
      const params = {
        ...this.filterForm,
        ...this.listQuery,
      };
      API.findSubject(params).then((res) => {
        if (res.status === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(row) {
      this.selectRows = row;
    },
  },
};
</script>
<style scoped lang="scss">
.btn-wrapper{
  .el-link{
    margin-right: 8px;
    &:last-child{
      margin-right: 0;
    }
  }
}
.el-upload__tip{
  font-size: 14px;
}

.auth {
  background: transparent;
  height: 100%;
  .title-bar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    .title {
      display: flex;
      align-items: center;
      .main {
        font-size: 20px;
        font-weight: 900;
        color: rgba(0, 0, 0, 0.6);
      }
      .sub {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
  .btn-handler {
    width: 160px;
  }

  .tools {
    display: flex;
    justify-content: space-between;

    .filter-wrapper {
      .search-input {
        width: 240px;
        height: 40px;
        font-size: 18px;
        line-height: 40px;

        /deep/ .el-input__inner {
          border-radius: 20px;
          padding-left: 35px;
        }

        /deep/ .el-input__prefix {
          left: 13px;
        }
      }
    }

    .btn-wrapper {
      /deep/ .el-button {
        width: 160px;
        height: 40px;
        color: rgba(154, 154, 154, 1);
      }

      /deep/ .el-button--primary {
        color: #fff;
      }
    }
  }
  .listLogo {
    padding-bottom: 10px;
    img {
      width: 28px;
      height: 20px;
    }
    span {
      font-size: 20px;
      padding-left: 10px;
    }
  }
  .content {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
    padding: 20px;
    box-sizing: border-box;
    height: calc(100% - 136px);
    .auth-table{
      height:calc(100% - 58px); ;
    }
    .table {
      margin-bottom: 30px;
    }

    .pagination {
      text-align: right;
    }
  }
  .titileContent {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
    margin-bottom: 20px;
    height: 88px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    .formContainer {
      width: 100%;
      height: 40px;
    }
  }

  .btn-table {
    font-size: 18px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    & + .btn-table {
      margin-left: 40px;
    }
  }
  .mute {
    color: rgba(1, 195, 141, 0.43);
  }
}
</style>
<style lang="scss">
#auth {
  .saveBtn,
  .cancelBtn {
    height: 30px;
    padding: 5px 10px;
  }
  .saveBtn {
    background-color: rgba(255, 101, 91, 1);
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .downLoadButton {
    background: rgba(231, 250, 241, 1);
    color: #19cc7b;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    display: inline-block;
    padding: 5px 10px;
    height: 30px;
  }
  .btn-expand {
    height: 30px;
  }
  .btn-operate-edit {
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: rgba(7, 41, 92, 1);
    margin-right: 20px;
  }
  .btn-operate-download {
    font-family: "Microsoft YaHei";
    font-weight: 400;
    display: inline-block;
    padding: 5px 10px;
    color: rgba(255, 101, 91, 1);
    height: 30px;
    background: rgba(255, 239, 238, 1);
  }
  .icon-transToDown {
    transform: rotate(90deg);
  }
  .icon-transToUp {
    transform: rotate(-90deg);
  }
  .saveBtn {
    background-color: rgba(255, 101, 91, 1);
  }
}
</style>
